import CacheDashboard from "../../../views/CacheDashboard";
import MenuNames from "../../../constants/Menu/MenuNames.json";

const CacheDashboardRoutes = [
    {
        menuName: MenuNames.OFS_CACHE_DASHBOARD,
        path: "/ofs-cache-dashboard",
        component: CacheDashboard,
        exact: true,
    }
];

export default CacheDashboardRoutes;